import { Injector } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { Router } from '@angular/router';
import { AuthService } from '@app/core/auth/auth.service';
import { ItauUserIdleService } from '@app/core/security/itau-user-idle.service';
import { EnvironmentService } from './core/environment/environment.service';
import { DatadogService } from './shared/services/datadog/datadog.service';
var AuthInterceptor = /** @class */ (function () {
    function AuthInterceptor(injector, environmentService, _datadogService) {
        this.injector = injector;
        this.environmentService = environmentService;
        this._datadogService = _datadogService;
    }
    AuthInterceptor.prototype.intercept = function (request, next) {
        var _this = this;
        var router = this.injector.get(Router);
        if (sessionStorage.getItem('sessionState') == 'true') {
            request = request.clone({
                withCredentials: true
            });
        }
        return next.handle(request)
            .pipe(catchError(function (error) {
            _this._datadogService.sendErrorLogs(error.message);
            _this.iServicesUri = _this.environmentService.envModel.appSettings.fm6ApiUrlFeatureToggle;
            if (error.status == 403) {
                var authService = _this.injector.get(AuthService);
                var userIdleService = _this.injector.get(ItauUserIdleService);
                if (error.url.indexOf(_this.iServicesUri) === -1) {
                    userIdleService.stopWatching();
                    authService.logout(true);
                    return throwError('Sessão Inválida');
                }
            }
            else {
                return throwError(error);
            }
        }));
    };
    return AuthInterceptor;
}());
export { AuthInterceptor };
